export const environment = {
  production: false,
  appEnv: 'dev',
  cognito: {
    region: 'undefined',
    userPoolId: 'us-east-2_JDUX7dvIV',
    userPoolWebClientId: 'jpi4b5rkkfiucfa9g88g0scmj',
  },
  warehouseApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/warehouse',
  sourcingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sourcing',
  salesApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sales',
  productApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/product',
  cognitoDomain: 'https://explorandes.auth.us-east-2.amazoncognito.com',
  isLocal: false,
};
